var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.917969 13.2913C0.917969 11.157 2.04023 9.28468 3.72687 8.23244C4.1856 4.62334 7.26759 1.83301 11.0013 1.83301C14.735 1.83301 17.817 4.62334 18.2757 8.23244C19.9624 9.28468 21.0846 11.157 21.0846 13.2913C21.0846 16.4278 18.6612 18.9982 15.5846 19.2323L6.41797 19.2497C3.34143 18.9982 0.917969 16.4278 0.917969 13.2913ZM15.4456 17.4042C17.5845 17.2415 19.2513 15.4511 19.2513 13.2913C19.2513 11.8494 18.5073 10.5379 17.3053 9.78793L16.5668 9.32712L16.457 8.46361C16.1103 5.7362 13.7777 3.66634 11.0013 3.66634C8.22486 3.66634 5.89223 5.7362 5.54558 8.46361L5.43581 9.32712L4.69728 9.78793C3.49523 10.5379 2.7513 11.8494 2.7513 13.2913C2.7513 15.4511 4.4181 17.2415 6.55703 17.4042L6.71589 17.4163H15.2867L15.4456 17.4042ZM11.918 11.9163V15.583H10.0846V11.9163H7.33464L11.0013 7.33301L14.668 11.9163H11.918Z",
    fill: "#656E7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.a7741fc0157975a8d967efdbb089ea03.svg";
export { ForwardRef as ReactComponent };